import { motion } from 'framer-motion'
import {
  HiLightningBolt,
  HiScale,
  HiShieldCheck,
  HiDatabase,
  HiUserGroup,
  HiLightBulb,
} from 'react-icons/hi'
import { SectionTitle } from '@/components/SectionTitle'
import { useLanguage } from '@/i18n/LanguageContext'

const itemIcons = [
  {
    icon: HiLightningBolt,
  },
  {
    icon: HiScale,
  },
  {
    icon: HiShieldCheck,
  },
  {
    icon: HiDatabase,
  },
  {
    icon: HiUserGroup,
  },
  {
    icon: HiLightBulb,
  },
]

export function Diferenciais() {
  const { t } = useLanguage()

  const items = itemIcons.map((entry, index) => ({
    icon: entry.icon,
    title: t.diferenciais.items[index].title,
    description: t.diferenciais.items[index].description,
  }))

  return (
    <section id="diferenciais" className="section-padding bg-white">
      <div className="container-custom">
        <SectionTitle
          title={t.diferenciais.title}
          subtitle={t.diferenciais.subtitle}
        />
        <motion.div
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.5 }}
        >
          {items.map((d, i) => (
            <motion.div
              key={d.title}
              className="flex gap-4 rounded-xl p-6 bg-slate-50 border border-slate-100 hover:border-primary-200 hover:bg-primary-50/30 transition-colors duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <d.icon className="h-5 w-5" />
              </div>
              <div>
                <h3 className="font-bold text-slate-900">{d.title}</h3>
                <p className="mt-1 text-slate-600 text-sm leading-relaxed">{d.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
